import { ICustomerPointTaskItem } from '@/api/types/account';
import { EPlatform } from '@/utils/enums/platform-enum';
import { env } from '@/utils/env';
// 积分的数据处理
const taskBaseData = [
  {
    name: 'buy',
    label_img: '/account/points-mall/task_img/shopping.png',
    btn_text: 'Go shopping',
    wap_btn_text: 'Go',
    jump_type: 3, // path | url ;path为站内路由跳转,url为跳转外链
    path: `/goods-list/${env.NEXT_PUBLIC_BASE_GOODS_LIST_ID}`,
  },
  {
    name: 'save_prescription',
    label_img: '/account/points-mall/task_img/prescription.png',
    btn_text: 'To fill in',
    wap_btn_text: 'Go',
    jump_type: 3, // path | url ;path为站内路由跳转,url为跳转外链
    path: '/account/my-prescriptions',
  },
  {
    name: 'verify_email',
    label_img: '/account/points-mall/task_img/email.png',
    btn_text: 'Get points',
    wap_btn_text: 'Go',
    jump_type: 3, // path | url ;path为站内路由跳转,url为跳转外链
    path: '/account/account-security',
  },
  {
    name: 'verify_tel',
    label_img: '/account/points-mall/task_img/verify-phone-number.png',
    btn_text: 'Get points',
    wap_btn_text: 'Go',
    jump_type: 3, // path | url ;path为站内路由跳转,url为跳转外链
    path: '/account/account-security',
  },
  {
    name: 'order_review',
    label_img: '/account/points-mall/task_img/review-order.png',
    btn_text: 'Get points',
    wap_btn_text: 'Go',
    jump_type: 3, // path | url ;path为站内路由跳转,url为跳转外链
    path: '/account/my-reviews',
  },
  {
    name: 'complete_questionnaire',
    label_img: '/account/points-mall/task_img/questionnaire.png',
    btn_text: 'To fill in',
    wap_btn_text: 'Go',
    jump_type: 3, // path | url ;path为站内路由跳转,url为跳转外链
    path: '/account/questionnaires-list',
  },
  {
    // 推荐购买
    name: 'recommend_buy',
    label_img: '/account/points-mall/task_img/purchase.png',
    btn_text: 'Tell a friend',
    wap_btn_text: 'Go',
    jump_type: 3, // path | url ;path为站内路由跳转,url为跳转外链
    path: '/account/refer-a-friend',
  },
  {
    // 推荐注册
    name: 'recommend_reg',
    label_img: '/account/points-mall/task_img/registration.png',
    btn_text: 'Tell a friend',
    wap_btn_text: 'Go',
    jump_type: 3, // path | url ;path为站内路由跳转,url为跳转外链
    path: '/account/refer-a-friend',
  },
  {
    name: 'join_fb',
    label_img: '/account/points-mall/task_img/fb.png',
    btn_text: 'Join',
    wap_btn_text: 'Go',
    jump_type: 4, // path | url ;path为站内路由跳转,url为跳转外链
    path: `${env.NEXT_PUBLIC_FB_GROUP}`,
  },
  {
    name: 'app_sign_in',
    label_img: '/account/points-mall/task_img/sign-in.png',
    // btn_text: 'Go',
    // path_type: 'url',// path | url ;path为站内路由跳转,url为跳转外链
    // path: 'https://zeelool.onelink.me/QxSq/k76k1dbw',
  },
  {
    name: 'join_member',
    label_img: '/account/points-mall/task_img/rewards.png',
    btn_text: 'Join in',
    wap_btn_text: 'Go',
    jump_type: 3, // path | url ;path为站内路由跳转,url为跳转外链
    path: '/account/zeelool-rewards',
  },
  {
    name: 'perfect_info',
    label_img: '/account/points-mall/task_img/information.png',
    btn_text: 'Get points',
    wap_btn_text: 'Go',
    jump_type: 3, // path | url ;path为站内路由跳转,url为跳转外链
    path: '/account/account-settings',
  },
];
const taskTips = {
  buy: () => {
    return ` Get points for successful order payment`;
  },
  save_prescription: (points: string | number) => {
    return `Earn ${points} ${
      Number(points) > 1 ? 'points' : 'point'
    } for saving a prescription for the first time`;
  },
  verify_email: (points: string | number) => {
    return `Successful email verification to get ${points} times ${
      Number(points) > 1 ? 'points' : 'point'
    }`;
  },
  verify_tel: (points: string | number) => {
    return `Successful mobile phone number verification can get ${points} ${
      Number(points) > 1 ? 'points' : 'point'
    }`;
  },
  order_review: (points: string | number) => {
    return `You can get ${points} ${Number(points) > 1 ? 'points' : 'point'} for reviewing orders`;
  },
  complete_questionnaire: (points: string | number) => {
    return `Get ${points} ${
      Number(points) > 1 ? 'points' : 'point'
    } for submitting the questionnaire for the first time`;
  },
  recommend_buy: (points: string | number) => {
    // return `Recommend friends to successfully place an order to get ${this.CrmPointRule?.reward?.recommend_buy_points} points`
    return `invite friends to successfully place an order to get ${points} ${
      Number(points) > 1 ? 'points' : 'point'
    }`;
  },
  recommend_reg: (points: string | number) => {
    // return `Recommend friends to successfully register and get ${this.CrmPointRule?.reward?.recommend_reg_points} points`
    return `invite friends to successfully register and get ${points} ${
      Number(points) > 1 ? 'points' : 'point'
    }`;
  },
  join_fb: (points: string | number) => {
    return `Successfully join the FB group for the first time to get ${points} ${
      Number(points) > 1 ? 'points' : 'point'
    }`;
  },
  app_sign_in: () => {
    return `Daily sign-in on the App can earn points`;
  },
  join_member: (points: string | number) => {
    return `Join Zeelool Rewards to Earn ${points} ${Number(points) > 1 ? 'points' : 'point'}`;
  },
  perfect_info: (points: string | number) => {
    return `Complete personal center information to get ${points} ${
      Number(points) > 1 ? 'points' : 'point'
    }`;
  },
};

export const handlePointsTask = (customerPointTask: ICustomerPointTaskItem[]) => {
  return customerPointTask.map((item) => {
    const tips = taskTips[item.name] ? taskTips[item.name](item.points) : '';
    const baseData = taskBaseData.find((v) => v.name === item.name);
    return { ...item, tips, ...baseData };
  });
};

export interface PointsTaskItemProps {
  item: {
    name?: string;
    label_img?: string;
    btn_text?: string;
    jump_type?: number;
    path?: string;
    tips?: string;
    title?: string;
    status?: number;
    wap_btn_text?: string;
    points?: string | number;
  };
  deviceType?: EPlatform;
}
